<!-- This component is used to display the address related input fields on the OAP Stripe payment -->
<template>
	<div class="address-input">
		<h5 class="text-secondary-400 pb-1 font-medium">
			{{ t('person.address') }}
		</h5>
		<div class="grid grid-cols-2 gap-0 rounded-lg">
			<FormKit
				type="autocomplete"
				id="addressCountry"
				name="addressCountry"
				:placeholder="
					t('plan.placeholders.select', {
						placeholderLabel: t('person.country'),
					})
				"
				:options="countryOptions"
				clear-search-on-open
				v-model="address.country"
				outer-class="col-span-2! max-w-full! mb-0!"
				inner-class="rounded-b-none! border-b-0 rounded-lg! border-slate-200! shadow-none!"
				wrapper-class="mb-0!"
			/>
			<FormKit
				id="addressLine1"
				name="addressLine1"
				outer-class="col-span-2! max-w-full! mb-0!"
				inner-class="rounded-none! border-b-0 border-slate-200! shadow-none!"
				:placeholder="t('person.addressLine1')"
				v-model="address.line1"
			/>
			<FormKit
				id="addressLine2"
				name="addressLine2"
				outer-class="col-span-2! max-w-full! mb-0!"
				inner-class="rounded-none! border-b-0 border-slate-200! shadow-none!"
				:placeholder="t('person.addressLine2')"
				v-model="address.line2"
			/>
			<FormKit
				id="addressCity"
				name="addressCity"
				outer-class="max-w-full! mb-0!"
				inner-class="rounded-none! border-b-0 border-r-0 border-slate-200! shadow-none!"
				:placeholder="t('person.city')"
				v-model="address.city"
			/>
			<FormKit
				id="postalCode"
				name="postalCode"
				outer-class="max-w-full! mb-0!"
				inner-class="rounded-none! border-b-0 border-slate-200! shadow-none!"
				:placeholder="t('person.postalCode')"
				v-model="address.postalCode"
			/>
			<FormKit
				id="addressState"
				name="addressState"
				outer-class="col-span-2! max-w-full! mb-0!"
				inner-class="rounded-t-none! rounded-lg! border-slate-200! shadow-none!"
				:placeholder="t('person.state')"
				v-model="address.state"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import { countryOptions } from '@/data/countryOptions'
import { usePresentationLocale } from '@/i18n'
import type { StripeBillingAddress } from '@/types'

const { t } = usePresentationLocale()

const address = defineModel<StripeBillingAddress>({ required: true })
</script>
